import React from 'react';
import InputLabel from '@mui/material/InputLabel'
import OutlinedInput, { OutlinedInputProps } from '@mui/material/OutlinedInput';
import { InputBaseComponentProps } from '@mui/material';


// export function ValidationWrapper(reactComponent, validationFunction) {
//   return ({value, className, ...args}) => {
//     const validationClassName = validationFunction(value) ? ' is-valid' : ' is-invalid'
//     return reactComponent({value: value, className: className + validationClassName, ...args})
//   }
// }

// function FormStyleWrapper(reactComponent, specialClassName) {
//   return ({label, id, className, ...args}) => 
//     <div className="label-and-input">
//       <label htmlFor={id}>{label}</label>
//       {reactComponent({id: id, className: className + ' ' + specialClassName, ...args})}
//     </div>
// }

// export function FormControlWrapper(reactComponent) {
//   return FormStyleWrapper(reactComponent, 'form-control')
// }

// export function FormSelectWrapper(reactComponent) {
//   return FormStyleWrapper(reactComponent, 'form-select')
// }

const styling = {py: '0.4rem!important', minWidth: '120px!important'}
//const styling = {py: '0.4rem!important'}



type StandardComponentProps<Value> = {
  sx: {}, value: Value, error: boolean, disabled: boolean
}
type StandardWrapperProps<Value> = {
  label?: string | React.JSX.Element, value: Value, disabled?: boolean, sx?: {}
}


export function FormWrapper<ComponentProps extends (
  StandardComponentProps<Value> extends Pick<ComponentProps, (keyof StandardComponentProps<Value> | keyof StandardWrapperProps<Value>) & keyof ComponentProps> ? {} : never
), Value = ComponentProps extends { value: infer V } ? V : unknown> (
  {Component, validationFunction}:
  {
    Component: React.ComponentType<ComponentProps>,
    // Optional: omit it for fields that are always valid. Its absence means
    // "no validation" — clearer than a `() => true` stub, and it avoids forcing
    // a meaningless validator (and unused param) on every such field.
    validationFunction?: (value: Value) => boolean
  }
) {
  return ({label, value, disabled, sx, ...extraProps}: StandardWrapperProps<Value> & Omit<ComponentProps, keyof StandardComponentProps<Value> | keyof StandardWrapperProps<Value>>) => {
    const error = !disabled && validationFunction !== undefined && !validationFunction(value)
    return (
      <InputLabel error={error}>
        <div><b>{label}</b></div>
        <Component
          sx={{
            '& .MuiSelect-outlined': styling,
            '& .MuiOutlinedInput-input': styling,
            '& .MuiOutlinedInput-root': {py: '0rem!important'},
            width: '100%',
            ...sx
          }}
          size="small" // This is not really type-safe, since the component might be surprised by this argument
          value={value}
          error={error}
          disabled={disabled}
          // Type cast necessary to make typescript understand that the props have the correct type; see https://github.com/microsoft/TypeScript/issues/28884.
          {...extraProps as unknown as ComponentProps}
        />
      </InputLabel>
    )
  }
}


export function InputWrapper(Component: React.ComponentType<{onChange?: (newValue: string) => void} & InputBaseComponentProps>) {

  const IntermediateWrapper = React.forwardRef((props: {onChange?: (newValue: string) => void} & InputBaseComponentProps, ref) => {
    //const { ...other } = props;
    return <Component inputRef={ref} {...props}/>
  });

  function InputRaw({...props}: Omit<OutlinedInputProps, 'onChange'> & {onChange: (newValue: string) => void}) {
    return (
      <OutlinedInput
        inputComponent={IntermediateWrapper}
        autoComplete="off"
        {...props as unknown as OutlinedInputProps}
      />
    )
  }

  return InputRaw
}
